import { render, staticRenderFns } from "./HCbySlug.vue?vue&type=template&id=78958b13&scoped=true&"
import script from "./HCbySlug.vue?vue&type=script&lang=js&"
export * from "./HCbySlug.vue?vue&type=script&lang=js&"
import style0 from "./HCbySlug.vue?vue&type=style&index=0&id=78958b13&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78958b13",
  null
  
)

export default component.exports